/**
 * Creates the HTLM for a failure message
 * @param {string} canvasContainerId id of container of th canvas.
 * @return {string} The html.
 */
const makeFailHTML = (msg) => {
  return (
    "" +
    '<div style="margin: auto; width:500px;z-index:10000;margin-top:20em;text-align:center;">' +
    msg +
    "</div>"
  );
};

/**
 * Message for getting a webgl browser
 * @type {string}
 */
const GET_A_WEBGL_BROWSER = "此页面需要您所使用的浏览器支持 WebGL（检测发现目前还不支持）!";

/**
 * Message for need better hardware
 * @type {string}
 */
const OTHER_PROBLEM ="此页面需要您所使用的系统支持 WebGL（检测发现目前还不支持）!";

/**
 * Creates a webgl context. If creation fails it will
 * change the contents of the container of the <canvas>
 * tag to an error message with the correct links for WebGL.
 * @param {Element} canvas. The canvas element to create a context from.
 * @param {WebGLContextCreationAttirbutes} opt_attribs Any creation attributes you want to pass in.
 * @param {function:(msg)} opt_onError An function to call if there is an error during creation.
 * @return {WebGLRenderingContext} The created context.
 */

const setupWebGL = (canvas, opt_attribs?: any, opt_onError?: any) => {
  function handleCreationError(msg) {
    var container = document.getElementsByTagName("body")[0];

    if (container) {
      var str = window.WebGLRenderingContext
        ? OTHER_PROBLEM
        : GET_A_WEBGL_BROWSER;

      if (msg) {
        str += "<br/><br/>Status: " + msg;
      }

      container.innerHTML = makeFailHTML(str);
    }
  }

  opt_onError = opt_onError || handleCreationError;

  if (canvas.addEventListener) {
    canvas.addEventListener(
      "webglcontextcreationerror",
      function (event) {
        opt_onError(event.statusMessage);
      },
      false
    );
  }

  var context = create3DContext(canvas, opt_attribs);

  if (!context) {
    if (!window.WebGLRenderingContext) {
      opt_onError("");
    } else {
      opt_onError("");
    }
  }

  return context;
};

/**
 * Creates a webgl context.
 * @param {!Canvas} canvas The canvas tag to get context
 * @return {!WebGLContext} The created context.
 */

const create3DContext = (canvas, opt_attribs) => {
  var names = ["webgl", "experimental-webgl", "webkit-3d", "moz-webgl"];
  var context = null;

  for (var ii = 0; ii < names.length; ++ii) {
    try {
      context = canvas.getContext(names[ii], opt_attribs);
    } catch (e) {
      console.log("[test]create3DContext error:", e);
    }

    if (context) {
      break;
    }
  }

  return context;
};

export const WebGLUtils = {
  create3DContext: create3DContext,
  setupWebGL: setupWebGL,
};

/**
 * Provides requestAnimationFrame in a cross browser
 */
if (!window.requestAnimationFrame) {
  window.requestAnimationFrame = (function () {
    return (
      window.requestAnimationFrame ||
      // @ts-ignore
      window.webkitRequestAnimationFrame ||
      window["oRequestAnimationFrame"] ||
      function (
        // function FrameRequestCallback
        callback,
        // DOMElement Element
        element
      ) {
        window.setTimeout(callback, 1000 / 60);
      }
    );
  })();
}

/**
 * ERRATA: 'cancelRequestAnimationFrame' renamed to 'cancelAnimationFrame' to reflect an update to the W3C Animation-Timing Spec.
 * Cancels an animation frame request.
 * Checks for cross-browser support, falls back to clearTimeout.
 * @param {number}  Animation frame request.
 */

if (!window.cancelAnimationFrame) {
  window.cancelAnimationFrame =
    window["cancelRequestAnimationFrame"] ||
    // @ts-ignore
    window.webkitCancelAnimationFrame ||
    window["webkitCancelRequestAnimationFrame"] ||
    window["oCancelAnimationFrame"] ||
    window["oCancelRequestAnimationFrame"] ||
    window.clearTimeout;
}
